module.exports = __webpack_public_path__ + "static/media/Ganga Ram Trust Building.2f25d7c4.jpg";